import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesModuleApiSuffixModels } from '@app/modules';
import { AppState } from '@app/reducers';
import { CustomDirectiveConfig, IApplicationResponse, ModulesBasedApiSuffix, onBlurActionOnDuplicatedFormControl, onFormControlChangesToFindDuplicate } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { loggedInUserData } from '@modules/others';
import { UserLogin } from '@modules/others/models';
import { CommercialProducts } from '@modules/sales/models/commercial-products.model';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-commercial-products-add-edit',
  templateUrl: './commercial-products-add-edit.component.html'
})

export class CommercialProductsAddEditComponent implements OnInit {
  commercialProductForm: FormGroup;
  commercialProductsArray: FormArray;
  commercialProductId: any;
  userData: UserLogin;
  stringConfig = new CustomDirectiveConfig({ isAlphaSpecialCharterOnly: true });

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private store: Store<AppState>,
    private crudService: CrudService, private router: Router, private rxjsService: RxjsService) {
    this.commercialProductId = this.activatedRoute.snapshot.queryParams.id;
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.userData = userData;
    })
  }

  ngOnInit(): void {
    this.createCommercialProductForm();
    if (this.commercialProductId) {
      this.getCommercialProductById().subscribe((response: IApplicationResponse) => {
        this.commercialProductsArray = this.getCommercialProduct;
        let editResponseObj = new CommercialProducts(response.resources);
        this.commercialProductsArray.push(this.createCommercialProductarray(editResponseObj));
        this.rxjsService.setGlobalLoaderProperty(false);
      });
    } else {
      this.commercialProductsArray = this.getCommercialProduct;
      this.commercialProductsArray.push(this.createCommercialProductarray());
      this.rxjsService.setGlobalLoaderProperty(false);
    }
  }

  getCommercialProductById(): Observable<IApplicationResponse> {
    return this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.SALES_API_COMMERCIAL_PRODUCTS,
      this.commercialProductId,
      false,
      null);
  }

  createCommercialProductForm(): void {
    this.commercialProductForm = this.formBuilder.group({
      commercialProductsArray: this.formBuilder.array([]),
    });
  }

  get getCommercialProduct(): FormArray {
    if (this.commercialProductForm) {
      return this.commercialProductForm.get("commercialProductsArray") as FormArray;
    }
  }

  createCommercialProductarray(commercialProducts?: CommercialProducts): FormGroup {
    let commercialPorudctData = new CommercialProducts(commercialProducts ? commercialProducts : undefined);
    let formControls = {};
    Object.keys(commercialPorudctData).forEach((key) => {
      formControls[key] = [{ value: commercialPorudctData[key], disabled: commercialProducts && (key != 'commercialProductName' && key != 'description') && commercialPorudctData[key] !== '' ? true : false },
      (key === 'commercialProductName' ? [Validators.required] : [])]
    });
    return this.formBuilder.group(formControls);
  }

  onFormControlChanges(formControlName: string, formArray: FormArray, formArrayName: string, currentCursorIndex: number): void {
    onFormControlChangesToFindDuplicate(formControlName, formArray, formArrayName, currentCursorIndex, this.commercialProductForm);
  }

  onBlur(formControlName: string, formArray: FormArray, e, index: number) {
    onBlurActionOnDuplicatedFormControl(formControlName, formArray, e, index);
  }

  addCommercialProduct() {
    if (this.commercialProductForm.invalid) {
      return;
    }
    this.commercialProductsArray = this.getCommercialProduct;
    let commercialProducts = new CommercialProducts();
    this.commercialProductsArray.insert(0, this.createCommercialProductarray(commercialProducts));
  }

  removeCommercialProduct(i: number): void {
    this.getCommercialProduct.removeAt(i);
  }

  submit() {
    if (this.commercialProductForm.invalid) {
      return;
    }
    this.commercialProductsArray.value.forEach((obj) => {
      obj["createdUserId"] = this.userData.userId;
      obj["modifiedUserId"] = this.userData.userId;
      obj["commercialProductId"] = this.commercialProductId;
    });
    let crudService: Observable<IApplicationResponse> = !this.commercialProductId ? this.crudService.create(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_COMMERCIAL_PRODUCTS, this.commercialProductsArray.value) :
      this.crudService.update(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.SALES_API_COMMERCIAL_PRODUCTS, this.commercialProductsArray.at(0).value);
    crudService.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess) {
        this.router.navigate(['/configuration/sales/leads'], { queryParams: { tab: 4 }, skipLocationChange: true });
      }
    });
  }

  redirectToListPage() {
    this.router.navigate(['/configuration/sales/leads'], { queryParams: { tab: 4 }, skipLocationChange: true });
  }
}